import { Action } from "@ngrx/store";

import { GlobalInfo } from "@intocare/interfaces";

export const SET_ONBOARDING_INFO = "[Core] Set Onboarding Info";

export class SetGlobalInfo implements Action {
	readonly type = SET_ONBOARDING_INFO;

	constructor(public payload: GlobalInfo) {}
}

export type Actions = SetGlobalInfo;
